import { render, staticRenderFns } from "./GoldList.vue?vue&type=template&id=7999e394&scoped=true&"
import script from "./GoldList.vue?vue&type=script&lang=js&"
export * from "./GoldList.vue?vue&type=script&lang=js&"
import style0 from "./GoldList.vue?vue&type=style&index=0&id=7999e394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999e394",
  null
  
)

export default component.exports